import React from "react";
import "./RadarBackground.css";

// One full turn of the sweep, in seconds. Blip delays are worked out from it,
// so each blip lights up just as the sweep passes over it.
const SWEEP_SECONDS = 8;

// Placements the sweep "finds": angle clockwise from 12 o'clock, distance
// from the centre in vmin. Kept outside ~30vmin so they sit around the card,
// not behind it.
const BLIPS = [
  { angle: 38, radius: 40, color: "var(--brand-blue)" },
  { angle: 96, radius: 46, color: "var(--brand-yellow)" },
  { angle: 142, radius: 36, color: "var(--brand-green)" },
  { angle: 205, radius: 44, color: "var(--brand-red)" },
  { angle: 262, radius: 38, color: "var(--brand-blue)" },
  { angle: 318, radius: 47, color: "var(--brand-green)" },
];

// The logo, set in motion: rings leave the centre one after another in the
// mark's order (blue, green, yellow, red), two seconds apart, so the screen
// always shows them as evenly spaced concentric circles.
const PULSES = ["blue", "green", "yellow", "red"];

export default function RadarBackground() {
  return (
    <div className="radar-bg" aria-hidden="true">
      <div className="radar-grid" />
      <div className="radar-sweep" />

      {PULSES.map((color, i) => (
        <span
          key={color}
          className="radar-pulse"
          style={{
            "--pulse-color": `var(--brand-${color})`,
            animationDelay: `${-(PULSES.length - 1 - i) * 2}s`,
          }}
        />
      ))}

      {BLIPS.map((b) => {
        const rad = (b.angle * Math.PI) / 180;
        return (
          <span
            key={b.angle}
            className="radar-blip"
            style={{
              left: `calc(50% + ${(Math.sin(rad) * b.radius).toFixed(2)}vmin)`,
              top: `calc(var(--radar-y) - ${(Math.cos(rad) * b.radius).toFixed(2)}vmin)`,
              "--blip-color": b.color,
              animationDelay: `${((b.angle / 360) * SWEEP_SECONDS).toFixed(2)}s`,
            }}
          />
        );
      })}
    </div>
  );
}
